import { CartAddEvent, ThemeEvents } from '@theme/events';
let occupied = [null, null];
let busy = false;
const mobileOffsets = new Map();
class BwCartQueue extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.onSubmit);
    this.mobile = window.matchMedia('(max-width: 600px)');
    this.mobile.addEventListener('change', this.refresh);
    this.addEventListener('scroll', this.rememberScroll, { capture: true, passive: true });
    document.addEventListener(ThemeEvents.cartUpdate, this.refresh);
    document.addEventListener(ThemeEvents.discountUpdate, this.refresh);
    this.observer = new MutationObserver(() => this.draw());
    this.observer.observe(this, { childList: true, subtree: true });
    requestAnimationFrame(() => this.draw());
  }
  disconnectedCallback() { this.mobile?.removeEventListener('change', this.refresh); this.removeEventListener('scroll', this.rememberScroll, true); this.observer?.disconnect(); this.removeEventListener('submit', this.onSubmit); document.removeEventListener(ThemeEvents.cartUpdate, this.refresh); document.removeEventListener(ThemeEvents.discountUpdate, this.refresh); }
  refresh = () => requestAnimationFrame(() => { if (this.isConnected) this.draw(); });
  rememberScroll = event => {
    if (this.mobile?.matches && event.target.matches?.('[data-bw-slots]')) mobileOffsets.set(this.dataset.sectionId, event.target.scrollLeft);
  };
  draw() {
    const template = this.querySelector('[data-bw-candidates]');
    const container = this.querySelector('[data-bw-slots]');
    if (!template || !container) return;
    const candidates = [...template.querySelectorAll('[data-bw-variant]')];
    const ids = candidates.map(card => card.dataset.bwVariant);
    const priorityId = candidates.find(card => card.dataset.bwPriority === 'care')?.dataset.bwVariant;
    occupied = occupied.map(id => ids.includes(id) ? id : null);
    // A newly eligible care kit leads even when both accessory slots were filled.
    if (priorityId) occupied = [priorityId, occupied.find(id => id && id !== priorityId) || null];
    for (let i = 0; i < 2; i++) if (!occupied[i]) occupied[i] = ids.find(id => !occupied.includes(id)) || null;
    const visibleIds = this.mobile.matches ? (priorityId ? [priorityId, ...ids.filter(id => id !== priorityId)] : ids) : occupied.filter(Boolean);
    container.tabIndex = this.mobile.matches ? 0 : -1;
    container.setAttribute('role', 'region');
    container.setAttribute('aria-label', this.querySelector('.bw-cart-offers-heading h3')?.textContent || 'Optional extras');
    const shown = [...container.querySelectorAll("[data-bw-variant]")].map(card => card.dataset.bwVariant);
    if (shown.join() !== visibleIds.join()) {
      container.replaceChildren(...visibleIds.map(id => candidates.find(card => card.dataset.bwVariant === id).cloneNode(true)));
      container.scrollLeft = this.mobile.matches ? (mobileOffsets.get(this.dataset.sectionId) || 0) : 0;
    }
    this.querySelector('.bw-cart-offers').hidden = visibleIds.length === 0;
  }
  onSubmit = async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-bw-variant]')) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    const status = this.querySelector('[data-bw-status]');
    status.classList.remove('bw-status-success');
    const button = form.querySelector('button');
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    let submitted = false;
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
      const response = await fetch(form.action + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }], sections, sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) { status.textContent = result.description || this.dataset.error; return; }
      submitted = true;
      if (!result.sections?.[this.dataset.sectionId]) throw new Error('Missing cart section');
      document.dispatchEvent(new CartAddEvent(result, 'bw-cart-queue', { sections: result.sections, source: 'bw-cart-queue' }));
      requestAnimationFrame(() => {
        const next = [...document.querySelectorAll('bw-cart-queue')].find(queue => queue.dataset.sectionId === this.dataset.sectionId && queue.getClientRects().length > 0);
        const message = next?.querySelector('[data-bw-status]');
        if (message) { message.classList.add('bw-status-success'); message.textContent = next.dataset.added; message.tabIndex = -1; message.focus({ preventScroll: true }); }
      });
    } catch {
      status.textContent = this.dataset.refreshError;
    } finally {
      busy = false;
      if (!submitted) button.disabled = false;
      this.removeAttribute('aria-busy');
    }
  };
}
if (!customElements.get('bw-cart-queue')) customElements.define('bw-cart-queue', BwCartQueue);

// Keep native wallet controls accessible without crowding the smallest drawers.
let narrowExpressOpen = false;
class BwExpressOptions extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;
    this.smallScreen = window.matchMedia('(max-width: 350px)');
    this.syncLayout();
    this.details.addEventListener('toggle', this.rememberToggle);
    this.smallScreen.addEventListener('change', this.syncLayout);
  }
  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.rememberToggle);
    this.smallScreen?.removeEventListener('change', this.syncLayout);
  }
  syncLayout = () => {
    this.details.open = !this.smallScreen.matches || narrowExpressOpen;
  };
  rememberToggle = () => {
    if (this.smallScreen.matches) narrowExpressOpen = this.details.open;
  };
}
if (!customElements.get('bw-express-options')) customElements.define('bw-express-options', BwExpressOptions);
